const config = {
    apiKey: 'c0703afc23fc229cf83c9e599923f44d'
  };
  
  export default config;
  